import { render } from "./SubmissionConfirmationCampaignList.vue?vue&type=template&id=78b75a5c&scoped=true"
import script from "./SubmissionConfirmationCampaignList.vue?vue&type=script&lang=js"
export * from "./SubmissionConfirmationCampaignList.vue?vue&type=script&lang=js"

import "./SubmissionConfirmationCampaignList.vue?vue&type=style&index=0&id=78b75a5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b75a5c"]])

export default __exports__